module.exports = __webpack_public_path__ + "img/bw.b75c3c5f.svg";